import { Phone, MessageSquare } from "lucide-react";
import { BUSINESS } from "@/data/site";

// Persistent click-to-call bar on mobile only.
export const MobileCallBar = () => (
  <div
    data-testid="mobile-call-bar"
    className="lg:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 border-t border-hairline bg-void/90 backdrop-blur-xl"
  >
    <a
      href={BUSINESS.phoneHref}
      data-testid="mobile-call-cta"
      className="cta-pulse flex items-center justify-center gap-2 py-4 bg-red-600 text-white font-semibold"
    >
      <Phone className="w-5 h-5" strokeWidth={2.5} /> Call Now
    </a>
    <a
      href="/contact"
      data-testid="mobile-quote-cta"
      className="flex items-center justify-center gap-2 py-4 text-stark font-medium"
    >
      <MessageSquare className="w-5 h-5" strokeWidth={2} /> Get a Quote
    </a>
  </div>
);
